module.exports = __webpack_public_path__ + "img/3ds.53b5f022.svg";